// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Экраны 9 и 9а «Рассылки» (утверждены 28.10.2026). */
.bc-pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  background: #f3f4f6;
  color: #4b5563;
}
.bc-pill.is-blue {
  background: var(--v2-blue-bg);
  color: #1d4fa8;
}
.bc-pill.is-ok {
  background: var(--v2-green-bg);
  color: var(--v2-green-text);
}
.bc-pill.is-err {
  background: #fee2e2;
  color: #b91c1c;
}
.bc-subs {
  padding: 0;
  overflow: hidden;
}
.bc-subs-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  flex-wrap: wrap;
}
.bc-stat {
  color: var(--v2-muted);
  font-size: 13px;
  white-space: nowrap;
}
.bc-stat b {
  color: var(--v2-primary);
  font-size: 16px;
  margin-right: 4px;
}
.bc-sep {
  width: 1px;
  height: 18px;
  background: var(--v2-border);
}
.bc-toggle {
  border: 0;
  background: none;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  color: var(--v2-primary);
  white-space: nowrap;
}
.bc-subs-list {
  border-top: 1px solid var(--v2-border-soft);
  padding: 12px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.bc-table {
  min-width: 720px;
}
.bc-table th,
.bc-table td {
  white-space: nowrap;
}
.bc-row {
  cursor: pointer;
}
.bc-row:hover td {
  background: var(--v2-bg);
}
.bc-title a {
  color: var(--v2-primary);
  font-weight: 600;
  text-decoration: none;
}
.bc-deliv {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 160px;
}
.bc-bar {
  display: block;
  height: 4px;
  border-radius: 4px;
  background: #e5e7eb;
  overflow: hidden;
}
.bc-bar i {
  display: block;
  height: 100%;
  background: var(--v2-blue);
}
.bc-bar.is-big {
  height: 8px;
}
.bc-fail {
  color: #c2410c;
}

/* 9а */
.bc-saved {
  margin-left: 4px;
  white-space: nowrap;
}
.bc-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  align-items: flex-start;
}
.bc-main {
  flex: 999 1 560px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.bc-side {
  flex: 1 1 320px;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.bc-card {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.bc-label {
  font-weight: 600;
  font-size: 13px;
}
.bc-bots {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 10px;
}
.bc-bot {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid var(--v2-border);
  border-radius: 12px;
  font: inherit;
  text-align: left;
  cursor: pointer;
  color: inherit;
}
.bc-bot.is-on {
  border: 2px solid var(--v2-primary);
  padding: 11px 13px;
}
.bc-bot:disabled {
  opacity: 0.5;
  cursor: default;
}
.bc-bot-name {
  display: block;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bc-text {
  height: auto;
  padding: 10px 12px;
  line-height: 1.5;
  resize: vertical;
}
.bc-media {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.bc-thumb {
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 10px;
  overflow: hidden;
  background: #f5ede4;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bc-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.bc-thumb-doc {
  font-size: 11px;
  font-weight: 700;
  color: #9a3412;
}
.bc-thumb button {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 0;
  background: rgba(17, 24, 39, 0.7);
  color: #fff;
  font-size: 10px;
  cursor: pointer;
}
.bc-add {
  border: 1px dashed #d1d5db;
  background: #fff;
  font-size: 20px;
  color: var(--v2-muted);
  cursor: pointer;
}
.bc-btn-row {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 3fr) auto;
  gap: 8px;
  align-items: center;
}
.bc-x {
  border: 0;
  background: none;
  color: var(--v2-muted);
  cursor: pointer;
  width: 28px;
}
.bc-add-btn {
  align-self: flex-start;
  border: 1px dashed #d1d5db;
  background: #fff;
  border-radius: 8px;
  height: 30px;
  padding: 0 10px;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
}
.bc-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.v2-btn.bc-danger {
  color: #dc2626;
  border-color: #fecaca;
}
.bc-steps {
  margin: 0;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: var(--v2-text-2);
}
.bc-test-row {
  display: flex;
  gap: 8px;
}
.bc-test-row input {
  flex: 1;
  min-width: 0;
}
.bc-code-steps {
  gap: 8px;
}
.bc-code-value {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 0.18em;
  color: var(--v2-primary);
  margin-top: 4px;
  user-select: all;
}
.bc-link-btn {
  align-self: flex-start;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  font: inherit;
  font-size: 13px;
}
.bc-ok {
  color: var(--v2-green-text);
  font-size: 13px;
  font-weight: 600;
}
.v2-btn.bc-send {
  height: 42px;
  justify-content: center;
}
.bc-kv {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  color: var(--v2-text-2);
}
`, "",{"version":3,"sources":["webpack://./src/pages/broadcasts/broadcasts.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA,OAAO;AACP;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,yDAAyD;EACzD,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,QAAQ;AACV;AACA;EACE,qEAAqE;EACrE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB","sourcesContent":["/* Экраны 9 и 9а «Рассылки» (утверждены 28.10.2026). */\n.bc-pill {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  background: #f3f4f6;\n  color: #4b5563;\n}\n.bc-pill.is-blue {\n  background: var(--v2-blue-bg);\n  color: #1d4fa8;\n}\n.bc-pill.is-ok {\n  background: var(--v2-green-bg);\n  color: var(--v2-green-text);\n}\n.bc-pill.is-err {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n.bc-subs {\n  padding: 0;\n  overflow: hidden;\n}\n.bc-subs-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 12px 16px;\n  flex-wrap: wrap;\n}\n.bc-stat {\n  color: var(--v2-muted);\n  font-size: 13px;\n  white-space: nowrap;\n}\n.bc-stat b {\n  color: var(--v2-primary);\n  font-size: 16px;\n  margin-right: 4px;\n}\n.bc-sep {\n  width: 1px;\n  height: 18px;\n  background: var(--v2-border);\n}\n.bc-toggle {\n  border: 0;\n  background: none;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  color: var(--v2-primary);\n  white-space: nowrap;\n}\n.bc-subs-list {\n  border-top: 1px solid var(--v2-border-soft);\n  padding: 12px 16px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.bc-table {\n  min-width: 720px;\n}\n.bc-table th,\n.bc-table td {\n  white-space: nowrap;\n}\n.bc-row {\n  cursor: pointer;\n}\n.bc-row:hover td {\n  background: var(--v2-bg);\n}\n.bc-title a {\n  color: var(--v2-primary);\n  font-weight: 600;\n  text-decoration: none;\n}\n.bc-deliv {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 160px;\n}\n.bc-bar {\n  display: block;\n  height: 4px;\n  border-radius: 4px;\n  background: #e5e7eb;\n  overflow: hidden;\n}\n.bc-bar i {\n  display: block;\n  height: 100%;\n  background: var(--v2-blue);\n}\n.bc-bar.is-big {\n  height: 8px;\n}\n.bc-fail {\n  color: #c2410c;\n}\n\n/* 9а */\n.bc-saved {\n  margin-left: 4px;\n  white-space: nowrap;\n}\n.bc-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px;\n  align-items: flex-start;\n}\n.bc-main {\n  flex: 999 1 560px;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.bc-side {\n  flex: 1 1 320px;\n  max-width: 420px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.bc-card {\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.bc-label {\n  font-weight: 600;\n  font-size: 13px;\n}\n.bc-bots {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 10px;\n}\n.bc-bot {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  background: #fff;\n  border: 1px solid var(--v2-border);\n  border-radius: 12px;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  color: inherit;\n}\n.bc-bot.is-on {\n  border: 2px solid var(--v2-primary);\n  padding: 11px 13px;\n}\n.bc-bot:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.bc-bot-name {\n  display: block;\n  font-weight: 700;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.bc-text {\n  height: auto;\n  padding: 10px 12px;\n  line-height: 1.5;\n  resize: vertical;\n}\n.bc-media {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.bc-thumb {\n  position: relative;\n  width: 64px;\n  height: 64px;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #f5ede4;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.bc-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.bc-thumb-doc {\n  font-size: 11px;\n  font-weight: 700;\n  color: #9a3412;\n}\n.bc-thumb button {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 0;\n  background: rgba(17, 24, 39, 0.7);\n  color: #fff;\n  font-size: 10px;\n  cursor: pointer;\n}\n.bc-add {\n  border: 1px dashed #d1d5db;\n  background: #fff;\n  font-size: 20px;\n  color: var(--v2-muted);\n  cursor: pointer;\n}\n.bc-btn-row {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(0, 3fr) auto;\n  gap: 8px;\n  align-items: center;\n}\n.bc-x {\n  border: 0;\n  background: none;\n  color: var(--v2-muted);\n  cursor: pointer;\n  width: 28px;\n}\n.bc-add-btn {\n  align-self: flex-start;\n  border: 1px dashed #d1d5db;\n  background: #fff;\n  border-radius: 8px;\n  height: 30px;\n  padding: 0 10px;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n}\n.bc-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.v2-btn.bc-danger {\n  color: #dc2626;\n  border-color: #fecaca;\n}\n.bc-steps {\n  margin: 0;\n  padding-left: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 13px;\n  color: var(--v2-text-2);\n}\n.bc-test-row {\n  display: flex;\n  gap: 8px;\n}\n.bc-test-row input {\n  flex: 1;\n  min-width: 0;\n}\n.bc-code-steps {\n  gap: 8px;\n}\n.bc-code-value {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 30px;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  color: var(--v2-primary);\n  margin-top: 4px;\n  user-select: all;\n}\n.bc-link-btn {\n  align-self: flex-start;\n  padding: 0;\n  border: 0;\n  background: none;\n  cursor: pointer;\n  font: inherit;\n  font-size: 13px;\n}\n.bc-ok {\n  color: var(--v2-green-text);\n  font-size: 13px;\n  font-weight: 600;\n}\n.v2-btn.bc-send {\n  height: 42px;\n  justify-content: center;\n}\n.bc-kv {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 13px;\n  color: var(--v2-text-2);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
